import {Injectable} from '@angular/core';
import {Camera} from '@capacitor/camera';
import {DocumentScanner, ResponseType} from '@capgo/capacitor-document-scanner';
import {ActionSheetController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {PermissionStatus} from '@capacitor/camera/dist/esm/definitions';
import {FileSourceAsset} from '../../../Models/Shared/file-source-asset.interface';
import {ToastManagerService} from '../Ionic/toast-manager.service';
import {FilePickerManagerService} from './file-picker-manager.service';

@Injectable({
  providedIn: 'root'
})
export class ScannerManagerService {

  private readonly maxFiles: number = 20;

  constructor(
    protected actionSheetCtrl: ActionSheetController,
    protected toastCtrl: ToastManagerService,
    protected filePickerManager: FilePickerManagerService,
    protected translate: TranslateService,
  ) {
  }


  /**
   * Mostrar las diferentes opciones para obtener el archivo
   *
   */
  public async chooseFileOptions(): Promise<FileSourceAsset[]> {

    return new Promise((resolve) => {

      (async () => {

        const actionSheet = await this.actionSheetCtrl.create({
          header: this.translate.instant('COMMON.OPTIONS'),
          buttons: [
            {
              text: this.translate.instant('COMMON.OPEN_CAMERA'),
              handler: async () => {
                resolve(await this.scanDocuments());
              }
            },
            {
              text: this.translate.instant('COMMON.SELECT_FILE'),
              handler: async () => {
                resolve(await this.filePickerManager.getFileFromDevice());
              }
            },
            {
              text: '',
              role: 'cancel',
            }
          ],
        });

        await actionSheet.present();

      })();

    });

  }


  /**
   * Escanear documentos
   *
   */
  public async scanDocuments(): Promise<FileSourceAsset[]> {

    const files: FileSourceAsset[] = [];
    const permission: PermissionStatus = await Camera.checkPermissions();

    if (permission.camera !== 'granted') {
      await Camera.requestPermissions();
    }

    try {
      const {scannedImages} = await DocumentScanner.scanDocument({responseType: ResponseType.Base64});

      if (!scannedImages) {
        return files;
      }

      if (files.length > this.maxFiles) {
        this.toastCtrl.showInfoToast(this.translate.instant('COMMON.MAX_FILES_ERROR'));
        return files;
      }

      for (const image of scannedImages) {

        files.push({
          original: image,
          response: await fetch(`data:image/jpg;base64,${image}`),
          extension: 'jpg',
          from: 'camera',
        })

      }
      
    } catch {
      return files;
    }

    return files;
  }

}
